/** Everything the shop page says. `{…}` are placeholders filled at runtime. */
export interface ShopCopy {
  eyebrow: string;
  title: string;
  lead: string;
  /** The row of colour swatches under the title (D-379). */
  byColour: string;
  seoTitle: string;
  seoDescription: string;
  search: { label: string; placeholder: string; suggestions: string; clear: string };
  sort: {
    label: string;
    featured: string;
    newest: string;
    priceAsc: string;
    priceDesc: string;
    relevance: string;
  };
  view: { label: string; grid: string; list: string };
  filters: {
    button: string;
    title: string;
    description: string;
    apply: string;
    clearAll: string;
    category: string;
    allCategories: string;
    color: string;
    finish: string;
    origin: string;
    application: string;
    thickness: string;
    price: string;
    availability: string;
    featured: string;
    minPrice: string;
    maxPrice: string;
    priceNote: string;
    loading: string;
  };
  active: { label: string; remove: string; featured: string; price: string };
  results: {
    heading: string;
    one: string;
    many: string;
    showing: string;
    loadMore: string;
    loadingMore: string;
    announce: string;
    announceOne: string;
    announceNone: string;
  };
  empty: { title: string; body: string; clear: string; ask: string };
  error: { title: string; body: string; retry: string };
}

export const content = {
  eyebrow: 'Pick your stone. We do the rest.',
  title: 'Granite slabs, tiles and countertops',
  lead: 'Natural granite in black, red, white, pink, brown and grey. Slabs, tiles and countertops for kitchens, floors, stairs and walls. Choose by colour, finish or use. Then ask us for your price.',
  byColour: 'Shop by colour',
  seoTitle: 'Granite Slabs, Tiles and Countertops',
  seoDescription:
    'Buy natural granite slabs, tiles and countertops in black, red, white, pink and brown. Polished stone from Rajsamand, India. Pick yours and ask for a price.',
  search: {
    label: 'Search our stones',
    placeholder: 'Try “Black Markino” or “red”',
    suggestions: 'Suggestions',
    clear: 'Clear search',
  },
  sort: {
    label: 'Sort by',
    featured: 'Our picks',
    newest: 'Newest',
    priceAsc: 'Price: low to high',
    priceDesc: 'Price: high to low',
    relevance: 'Best match',
  },
  view: { label: 'View', grid: 'Grid', list: 'List' },
  filters: {
    button: 'Filters',
    title: 'Filter stones',
    description: 'The numbers show how many stones match.',
    apply: 'Show {count} stones',
    clearAll: 'Clear all',
    category: 'Type',
    allCategories: 'All types',
    color: 'Colour',
    finish: 'Finish',
    origin: 'Where it is from',
    application: 'Use',
    thickness: 'Thickness',
    price: 'Price',
    availability: 'Stock',
    featured: 'Our picks only',
    minPrice: 'Lowest price',
    maxPrice: 'Highest price',
    priceNote: 'Each price is per sq ft or per slab.',
    loading: 'Loading…',
  },
  active: {
    label: 'Filters you picked',
    remove: 'Remove filter: {label}',
    featured: 'Our picks',
    price: '{min} – {max}',
  },
  results: {
    heading: 'Stones',
    one: '1 stone',
    many: '{count} stones',
    showing: 'Showing {shown} of {total}',
    loadMore: 'Show more stones',
    loadingMore: 'Loading…',
    announce: '{count} stones found',
    announceOne: '1 stone found',
    announceNone: 'No stones found',
  },
  empty: {
    title: 'No stones match these filters',
    body: 'Remove a filter or two. Or tell us what you need, and we will help you find the right granite.',
    clear: 'Clear all filters',
    ask: 'Ask about a stone',
  },
  error: {
    title: 'We could not load the stones',
    body: 'Please check your internet and try again. Your stones are only a tap away.',
    retry: 'Try again',
  },
} satisfies ShopCopy;
